<template>
    <div class="indent">
        <div class="banner">
        </div>
        <div class="wrapper">
            <div class=WordSection1 style='layout-grid:15.6pt'>

<p class=MsoListParagraph style='margin-left:18.0pt;text-indent:-18.0pt;
mso-char-indent-count:0;mso-list:l0 level1 lfo1'><span
lang=EN-US style='mso-fareast-font-family:等线;mso-fareast-theme-font:minor-latin;
mso-bidi-font-family:等线;mso-bidi-theme-font:minor-latin'><span
style='mso-list:Ignore'>1、<span style='font:7.0pt "Times New Roman"'> </span></span></span>运行软件，在弹出的“注册购买”窗口中可以看到机器码</p>

<p class=MsoListParagraph style='margin-left:18.0pt;text-indent:0cm;mso-char-indent-count:
0'><span lang=EN-US style='mso-no-proof:yes'><img width=543 height=486
:src="img1" v:shapes="图片_x0020_1"></span></p>

<p class=MsoListParagraph style='margin-left:18.0pt;text-indent:-18.0pt;
mso-char-indent-count:0;mso-list:l0 level1 lfo1'><span
lang=EN-US style='mso-fareast-font-family:等线;mso-fareast-theme-font:minor-latin;
mso-bidi-font-family:等线;mso-bidi-theme-font:minor-latin'><span
style='mso-list:Ignore'>2、<span style='font:7.0pt "Times New Roman"'> </span></span></span>点击按钮<span
lang=EN-US style='mso-no-proof:yes'><!--[if gte vml 1]><v:shape id="图片_x0020_2"
 o:spid="_x0000_i1025" type="#_x0000_t75" style='width:93pt;height:24.75pt;
 visibility:visible;mso-wrap-style:square'>
 <v:imagedata src="取机器码（新版题库）.files/image002.png" o:title=""/>
</v:shape><![endif]--><img width=124 height=33
:src="img2" v:shapes="图片_x0020_2"></span>，机器码复制成功。</p>

<p class=MsoListParagraph style='margin-left:18.0pt;text-indent:-18.0pt;
mso-char-indent-count:0;mso-list:l0 level1 lfo1'><span
lang=EN-US style='mso-fareast-font-family:等线;mso-fareast-theme-font:minor-latin;
mso-bidi-font-family:等线;mso-bidi-theme-font:minor-latin'><span
style='mso-list:Ignore'>3、<span style='font:7.0pt "Times New Roman"'> </span></span></span>把复制的机器码发给我们，我们会为您在线开通授权。</p>

</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            img1: require('./images/image001.png'),
            img2: require('./images/image002.png'),
        }
    }
}
</script>
<style lang="less">
    .indent{
        .banner{
            position: fixed;
            top: 0;
            left: 0;
            height: 60px;
            width: 100%;
            background: #198AF7;
        }
        .wrapper{
            padding-top: 60px;
            width: 1200px;
            margin: 0 auto;
            font-size: 16px;
        }
    }
</style>